<template>
  <div class="skeleton-list">
    <div v-if="isLoading" class="skeleton-list__items">
      <div
        v-for="i in itemsCount"
        :key="i"
        class="skeleton-card"
      >
        <div class="skeleton-card__company">
          <div class="skeleton-stack">
            <div class="skeleton-center">
              <div class="skeleton skeleton--logo"></div>
            </div>
            <div class="skeleton-center">
              <div class="skeleton skeleton--text skeleton--text-lg"></div>
            </div>
            <div class="skeleton-center">
              <div class="skeleton skeleton--text skeleton--text-sm"></div>
            </div>
          </div>
        </div>

        <div class="skeleton-card__details">
          <div class="skeleton-stack">
            <div class="skeleton skeleton--text skeleton--text-lg"></div>
            <div class="skeleton skeleton--button"></div>
          </div>
        </div>

        <div class="skeleton-card__pricing">
          <div class="skeleton-stack">
            <div class="skeleton-center">
              <div class="skeleton skeleton--text skeleton--text-lg"></div>
            </div>
            <div class="skeleton-center">
              <div class="skeleton skeleton--button"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <slot v-else />
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    itemsCount: {
      type: Number,
      default: 4,
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton {
  border-radius: 4px;
  background: linear-gradient(90deg, #f1efef -24.18%, #f9f8f8 50.26%, #e7e5e5 114.84%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  flex-shrink: 0;

  &-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &-center {
    display: flex;
    justify-content: center;
  }

  &--text {
    height: 18px;

    &-sm {
      width: 20%;
    }

    &-lg {
      width: 80%;
    }
  }

  &--logo {
    width: 150px;
    height: 55px;
  }

  &--button {
    width: 100%;
    height: 45px;
  }
}

.skeleton-list {
  &__items {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.skeleton-card {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.06), 0 1px 3px 0 rgb(0 0 0 / 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  &__company {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 190px;
    padding: 16px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  &__details {
    flex: 1;
    padding: 16px;
    border-left: 1px solid #cbd5e1;
    border-right: 1px solid #cbd5e1;

    @media (max-width: 768px) {
      width: 100%;
      border-left: none;
      border-right: none;
    }
  }

  &__pricing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 190px;
    padding: 16px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
}
</style>